/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneArticleTeaserDefault as ResolvedStandaloneArticleTeaserDefault } from 'base/components/standalone/ArticleTeaser/Default';

export const ArticleTeaserDefault: typeof ResolvedStandaloneArticleTeaserDefault = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneArticleTeaserDefault {...props} />
    );
});

export type ArticleTeaserDefaultProps = PropsFromComponent<typeof ArticleTeaserDefault>;

/** @deprecated Use slot architecture instead */
export const ArticleTeaserDefaultWith = (extras: DynamicStandaloneExtras): typeof ArticleTeaserDefault => {
    return function ArticleTeaserDefault(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleTeaserDefault');
        return <ResolvedStandaloneArticleTeaserDefault {...mergeProps({ options: { theme } }, props)} />;
    }
}